import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';
import { generateDxfFileInternal } from '../../render/dxf';

export const downloadDxfMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Download Dxf File',
		displayModes: [DisplayMode.Panel],

		onClick: ({ controller }): void => generateDxfFileInternal(controller)
	}
};
